export default __webpack_public_path__ + "static/media/blogIndex5.6a534b30.png";